import React, { useEffect } from "react";
import styled from "styled-components";
import ExtensionDealSideBar from "./ExtensionDealSideBar";
import ExtensionViewDeal from "./ExtensionViewDeal";
import ExtensionEditDeal from "./ExtensionEditDeal";
import { useExtensionContext } from "../ExtensionContext";
import useGetWonDealsByAccountId from "app/popleads/hooks/useGetWonDealsByAccountId";

const DealsContainer = styled.div`
    display: flex;
    width: 100%;
    height: 100%;
`;

const DealsMenu = styled.div`
    width: 225px;
    height: 100%;
    border-right: 1px solid ${({ theme }) => theme.colors?.neutral?.[100] || "#E5E7EB"};
`;

const DealsContent = styled.div`
    width: 100%;
    height: 100%;
    padding: 24px;
    overflow-y: auto;
`;

const ExtensionDealsPage = () => {
    const { isDealEditing, selectedDeal, profile } = useExtensionContext();
    const { wonDeals, fetchWonDealsByAccountId } = useGetWonDealsByAccountId();

    useEffect(() => {
        if (selectedDeal?.accountId) {
            fetchWonDealsByAccountId(selectedDeal.accountId);
        }
    }, [selectedDeal]);

    return (
        <DealsContainer>
            {profile?.olanak?.length > 0 ? (
                <>
                    <DealsMenu>
                        <ExtensionDealSideBar />
                    </DealsMenu>
                    <DealsContent>
                        {isDealEditing ? (
                            <ExtensionEditDeal />
                        ) : selectedDeal ? (
                            <ExtensionViewDeal wonDeals={wonDeals} />
                        ) : null}
                    </DealsContent>
                </>
            ) : (
                <div
                    style={{
                        width: "100%",
                        height: "100%",
                        display: "flex",
                        justifyContent: "center",
                        flexDirection: "column",
                        alignItems: "center",
                    }}
                >
                    <i className="flaticon2-warning text-warning icon-4x errorIcon"></i>
                    <div style={{ fontSize: "16px", fontWeight: "500", color: "#333" }}>
                        No deals found, please create a new deal
                    </div>
                </div>
            )}
        </DealsContainer>
    );
};

export default ExtensionDealsPage;
